import { createContext, useContext, useState, useCallback } from "react";

const PresentationContext = createContext(null);
const KEY = "fo_presentation_mode";

export function PresentationProvider({ children }) {
  const [mode, setModeState] = useState(() => localStorage.getItem(KEY) || "live");
  const setMode = useCallback((m) => {
    setModeState(m);
    localStorage.setItem(KEY, m);
  }, []);
  const toggle = useCallback(() => setMode(mode === "demo" ? "live" : "demo"), [mode, setMode]);
  return (
    <PresentationContext.Provider value={{ mode, isDemo: mode === "demo", setMode, toggle }}>
      {children}
    </PresentationContext.Provider>
  );
}

export const usePresentation = () => useContext(PresentationContext);
